export enum CheckoutUpsellArea {
    MENU = 'menu page',
    CHECKOUT = 'checkout page',
}
  